import type {
  AccordionContextProps,
  ChangeActive,
} from '@pearlconvert/ui/components/accordion/accordion.types'

import React, { createContext } from 'react'

export const AccordionActiveIdsContext = createContext([] as string[])
export const AccordionChangeActiveContext = createContext(
  (() => {}) as ChangeActive
)
export const AccordionIsInitial = createContext(true)
export const AccordionAnimationDelay = createContext<number>(0)

export function AccordionContext({
  activeIds,
  changeActive,
  isInitial,
  animationDelay = 0,
  children,
}: AccordionContextProps) {
  return (
    <AccordionActiveIdsContext.Provider value={activeIds}>
      <AccordionChangeActiveContext.Provider value={changeActive}>
        <AccordionIsInitial.Provider value={isInitial}>
          <AccordionAnimationDelay.Provider value={animationDelay}>
            {children}
          </AccordionAnimationDelay.Provider>
        </AccordionIsInitial.Provider>
      </AccordionChangeActiveContext.Provider>
    </AccordionActiveIdsContext.Provider>
  )
}
